import React from 'react';
import { CheckCircle } from '@phosphor-icons/react';

const ResultStat = ({ color, value, label }) => (
  <div className={`bg-${color}-50 rounded-lg p-3`}>
    <p className={`text-2xl font-bold text-${color}-700`}>{value}</p>
    <p className={`text-xs text-${color}-600`}>{label}</p>
  </div>
);

/**
 * Step 3 of the import flow — success page after the /import/execute call.
 * Pure presentational.
 */
const ImportResult = ({ result, importType }) => (
  <div className="text-center py-8">
    <CheckCircle size={64} className="mx-auto mb-4 text-emerald-500" />
    <h3 className="text-xl font-semibold text-slate-900 mb-2">Import Complete!</h3>
    <p className="text-slate-500 mb-6">
      Successfully imported {result.imported_count} {importType}s
    </p>
    <div className="grid grid-cols-3 gap-4 max-w-md mx-auto">
      <ResultStat color="emerald" value={result.imported_count} label="Imported" />
      <ResultStat color="amber" value={result.skipped_count} label="Skipped" />
      <ResultStat color="red" value={result.error_count} label="Errors" />
    </div>
  </div>
);

export default ImportResult;
